import { InjectionToken } from '@angular/core';
import { JobOpportunitiesButtonTitlesEnum } from '../enums/job-opportunities-button-titles.enum';

export const JOB_OPPORTUNITIES_BUTTON_TITLES_TOKEN =
    new InjectionToken<Partial<Record<JobOpportunitiesButtonTitlesEnum, string>>>('Job opportunities text titles');
